import React from 'react';
import OrderTotalTile from '~/components/Order/OrderTotalTile';
import Services from '~/components/Services/Services';
import { useStore } from '~/shared/hooks/useStore';
import classes from './OrderDetails.module.scss';

const OrderDetails = () => {
    const { COrder } = useStore();
    const { order } = COrder;
    const { order_sum, count_of_services } = order.order_info;

    return (
        <>
            <h1 className={classes.title}>Детали заказа</h1>
            <OrderTotalTile
                sum={order_sum}
                serviceCount={count_of_services}
            />
            <Services hasScrollToTopButton={false} />
        </>
    );
};

export default OrderDetails;
